/**
 * THE BROWSE TILE STILLS — one generated environment picture per genre and per
 * collection, served from `web/public/browse/`.
 *
 * These are OUR OWN images, generated as one batch in one aesthetic (moody
 * cinematic environments, near-black neutrals, a restrained warm undertone —
 * the Rouge palette's language) precisely so a genre tile never has to borrow
 * one arbitrary title's cover art to stand for forty others. No file carries
 * text, logos, recognisable characters or anybody's IP.
 *
 * These helpers only BUILD paths; they do not promise the file exists.
 * `PlateRail` treats a missing or failing image as a soft miss and falls back
 * to its gradient plate, so an unshipped picture costs a look, not a layout.
 */

/** `Sci-Fi` → `/browse/genre-sci-fi.webp`. Cinemeta genre names are letters
 *  and hyphens only (see `nav.svelte.ts`), so lowercasing is the whole map. */
export function genreArt(genre: string): string {
  return `/browse/genre-${genre.toLowerCase()}.webp`;
}

/** A collection's tile still, by its slug. */
export function collectionArt(slug: string): string {
  return `/browse/collection-${slug}.webp`;
}
